import { SpreadsheetMappingType } from 'api'
import { CurveMappingDialogColumns } from 'view/shared/datagrid/curveUpload/CurveMappingDialogColumns'
import { parseCurveSpreadsheet } from 'view/shared/datagrid/curveUpload/parseCurveSpreadsheet'
import { PendingCurvePriceUploadPanel } from 'view/shared/datagrid/curveUpload/PendingCurvePriceUploadPanel'
import { processCurveFileClipboardToRowData } from 'view/shared/datagrid/curveUpload/processCurveFileClipboardToRowData'
import { validateCurveParseResult } from 'view/shared/datagrid/curveUpload/validateCurveParseResult'
import { IncomingUploadDialogProps } from 'view/shared/incomingUpload'

export const CurveUploadDialogProps: Partial<IncomingUploadDialogProps> = {
  processFileClipboardToRowData: processCurveFileClipboardToRowData,
  parseIncomingSpreadsheet: parseCurveSpreadsheet,
  validateIncomingParseResult: validateCurveParseResult,
  spreadsheetMappingType: SpreadsheetMappingType.CURVE,
  PendingIncomingPanelComponent: PendingCurvePriceUploadPanel,
  MappingDialogColumnComponent: CurveMappingDialogColumns
}
